import Tippy from '@tippyjs/react';
import { Children, Component } from 'react';
import styled from 'styled-components';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { theme } from '../theme';

const TooltipContentWrapper = styled.div`
  color: ${theme.vars.newColor.darkGS1};
  font-size: 14px;
`;

export type Position = 'left' | 'right' | 'top' | 'bottom';

interface IProps {
  /** A simple title for the tooltip. */
  title?: string;
  /** Placement of the tooltip overlay. One of "left", "right" (default), "top", "bottom". */
  position?: Position;
  /** Choose action to trigger tooltip. One of "mouseenter" (default), "focus click" */
  trigger?: string;
  /** Custom HTML content for the tooltip (overrides title). */
  html?: any;
  /** Distance of the tooltip from the wrapped element in pixels. Defaults to 10. */
  distance?: number;
  /** Offsets the tooltip on its opposite axis. Defaults to 0. */
  offset?: number;
  /**
   * Prevents the tooltip from being positioned outside of it's container. Defaults to true.
   */
  preventOverflow?: boolean;
  /** Optional styling for the child wrapper div */
  wrapperStyle?: any;
}

export class Tooltip extends Component<IProps> {
  public static defaultProps: Pick<IProps, 'position' | 'trigger' | 'distance' | 'preventOverflow' | 'wrapperStyle'> = {
    position: 'right',
    trigger: 'mouseenter',
    distance: 10,
    preventOverflow: true,
    wrapperStyle: {},
  };
  public render() {
    const content = this.props.html ?? this.props.title;

    return (
      <Tippy
        placement={this.props.position}
        trigger={this.props.trigger}
        arrow={true}
        content={content ? <TooltipContentWrapper>{content}</TooltipContentWrapper> : null}
        offset={[this.props.offset, this.props.distance]}
        popperOptions={{
          modifiers: [
            {
              name: 'hide',
              enabled: true,
            },
            {
              name: 'preventOverflow',
              enabled: true,
            },
          ],
        }}
        theme="light"
        maxWidth={450}
      >
        <div style={this.props.wrapperStyle}>{Children.only(this.props.children)}</div>
      </Tippy>
    );
  }
}
